var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.176 2.086 4.266 8.792c.304.517.812.93 1.422 1.034l9.547 1.448c1.523.207 2.133 2.172 1.016 3.31l-6.907 6.826a1.93 1.93 0 0 0-.508 1.655l1.625 9.62c.305 1.55-1.32 2.792-2.742 1.965l-8.532-4.551a1.718 1.718 0 0 0-1.726 0l-8.532 4.55c-1.422.725-2.945-.413-2.742-1.965l1.625-9.619a1.93 1.93 0 0 0-.508-1.655L1.573 16.67c-1.117-1.138-.507-3 1.016-3.31l9.547-1.448c.61-.103 1.118-.517 1.422-1.034l4.266-8.792c.61-1.448 2.64-1.448 3.352 0z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.023
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar11);
export default __webpack_public_path__ + "static/media/star11.9ca796ce.svg";
export { ForwardRef as ReactComponent };